export default "__VITE_ASSET__4baf9f9b__$_?nuxt_component=async&nuxt_component_name=SvgoFreesteam__"